
// @ts-ignore
    import __i18nConfig from '@next-translate-root/i18n'
// @ts-ignore
    import __loadNamespaces from 'next-translate/loadNamespaces'
// @ts-ignore
    
import { NextPage } from 'next'
import { useRouter } from 'next/router'
import { useSession } from 'next-auth/react'
import useTranslation from 'next-translate/useTranslation'

import WebIdentificationForm from '@/components/forms/webIdentificationForm'
import BaseLayout from '@/components/layouts/BaseLayout'
import BaseCard from '@/components/ui/Cards/BaseCard'
import ContentWrapper from '@/components/ui/ContentWrapper'
import InfoPopup from '@/components/ui/Popups/InfoPopup'
import ButtonText from '@/components/ui/Typo/ButtonText'
import Caption from '@/components/ui/Typo/Caption'
import { IconIdentification, IconSecurity } from '@/res/icons'
import {
  NAMESPACE_IDENTIFICATION_PAGE,
  NAMESPACE_PROFILE_PAGE,
} from '@/res/namespaces'
import { ROUTE_IDENTIFICATION, ROUTE_PERSONAL_INFO } from '@/res/routes'

const IdentificationPage: NextPage = () => {
  const { t } = useTranslation(NAMESPACE_IDENTIFICATION_PAGE)
  const profileT = useTranslation(NAMESPACE_PROFILE_PAGE)
  const router = useRouter()
  const showInfoPopup = router.query.show_info === 'true'
  const { data } = useSession()

  const onClose = () => {
    const queries = { ...router.query }
    delete queries['show_info']
    router.replace({
      pathname: router.pathname,
      query: queries,
    })
  }

  const customComponent =
    data?.user.application_status === 'in_progress' ? (
      <div className="px-6 py-4 flex items-center">
        <ButtonText size="small" color="text-dark" className="text-center">
          {profileT.t('verification_status')}:{' '}
        </ButtonText>
        <Caption
          color="text-white"
          className="bg-yellow-500 ml-3 py-1 px-3 rounded"
        >
          {profileT.t('in_progress')}
        </Caption>
      </div>
    ) : null

  return (
    <BaseLayout seoTitle={t('seo_title')} seoDescription={t('seo_description')}>
      {showInfoPopup && <InfoPopup onClose={onClose} text={t('info_text')} />}
      <ContentWrapper>
        {!data?.user.application_status ||
        data?.user.application_status === 'declined' ? (
          <div>
            <div className="w-full px-2 sm:px-0">
              <WebIdentificationForm />
            </div>
          </div>
        ) : (
          <div className="mt-8 flex justify-center gap-x-4">
            {data?.user.application_status === 'verified' ||
            data?.user.application_status === 'confirmed' ? (
              <BaseCard
                title={profileT.t('personal_information')}
                description={profileT.t('personal_information_description')}
                linkText={profileT.t('view_personal_information')}
                link={ROUTE_PERSONAL_INFO}
                icon={IconSecurity.src}
              />
            ) : (
              <BaseCard
                title={profileT.t('identify_yourself')}
                description={profileT.t('identify_yourself_description')}
                linkText={profileT.t('complete_identification')}
                link={ROUTE_IDENTIFICATION}
                icon={IconIdentification.src}
                customComponent={customComponent}
              />
            )}
          </div>
        )}
      </ContentWrapper>
    </BaseLayout>
  )
}

export default IdentificationPage


// @ts-ignore
    export async function getStaticProps(ctx) {
// @ts-ignore
        
// @ts-ignore
        
// @ts-ignore
        return {
// @ts-ignore
          
// @ts-ignore
          
// @ts-ignore
          props: {
// @ts-ignore
            
// @ts-ignore
            ...(await __loadNamespaces({
// @ts-ignore
              ...ctx,
// @ts-ignore
              pathname: '/face-id',
// @ts-ignore
              loaderName: 'getStaticProps',
// @ts-ignore
              ...__i18nConfig,
// @ts-ignore
              loadLocaleFrom: (l, n) => import(`@next-translate-root/locales/${l}/${n}`).then(m => m.default),
// @ts-ignore
            }))
// @ts-ignore
          }
// @ts-ignore
        }
// @ts-ignore
    }
// @ts-ignore
  